import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

import './theme/tokens.css';
import './theme/app.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The pet is time-sensitive by nature: never serve a cached snapshot as fresh.
      staleTime: 0,
      refetchOnReconnect: true,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element.');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
